import { Button, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles(theme => {
  const colors = theme.palette;

  return {
    root: {
      color: colors.white,
      textTransform: 'none',
      border: '2px solid',
      boxSizing: 'border-box',
      '&:disabled': {
        pointerEvents: 'none'
      }
    },
    primary: {
      backgroundColor: colors.primary.main,
      borderColor: colors.primary.main,
      '&:hover': {
        color: colors.primary.main,
        backgroundColor: colors.white
      },
      '&:active': {
        borderColor: colors.primary.light,
        backgroundColor: colors.primary.light,
        color: colors.primary.main
      },
      '&:disabled': {
        borderColor: colors.primary.disabled,
        backgroundColor: colors.primary.disabled,
        color: colors.white
      }
    },
    accent: {
      backgroundColor: colors.accent.main,
      borderColor: colors.accent.main,
      '&:hover': {
        color: colors.accent.main,
        backgroundColor: colors.white
      },
      '&:active': {
        borderColor: colors.accent.light,
        backgroundColor: colors.accent.light,
        color: colors.accent.main
      },
      '&:disabled': {
        borderColor: colors.accent.disabled,
        backgroundColor: colors.accent.disabled,
        color: colors.white
      }
    },
    secondary: {
      backgroundColor: colors.secondary.main,
      borderColor: colors.secondary.main,
      '&:hover': {
        color: colors.secondary.main,
        backgroundColor: colors.white
      },
      '&:active': {
        borderColor: colors.secondary.light,
        backgroundColor: colors.secondary.light,
        color: colors.secondary.main
      },
      '&:disabled': {
        borderColor: colors.secondary.disabled,
        backgroundColor: colors.secondary.disabled,
        color: colors.white
      }
    },
    lime: {
      color: colors.primary.main,
      backgroundColor: colors.lime.main,
      borderColor: colors.lime.main,
      '&:hover': {
        backgroundColor: colors.white
      },
      '&:active': {
        borderColor: colors.lime.light,
        backgroundColor: colors.lime.light
      },
      '&:disabled': {
        borderColor: colors.lime.disabled,
        backgroundColor: colors.lime.disabled,
        color: colors.primary.disabled
      }
    },
    grey: {
      borderColor: colors.grey.dark,
      backgroundColor: colors.grey.dark,
      '&:hover': {
        color: colors.grey.dark,
        backgroundColor: colors.white,
        borderColor: colors.grey.medium
      },
      '&:active': {
        color: colors.grey.dark,
        backgroundColor: colors.grey.medium,
        borderColor: colors.grey.medium
      },
      '&:disabled': {
        color: colors.white,
        backgroundColor: colors.grey.medium,
        borderColor: colors.grey.medium
      }
    }
  };
});

const ThemeButton = ({ children, themeColor, size, disabled, onClick, ...rest }) => {
  const classes = useStyles();

  return (
    <Button
      disabled={disabled}
      size={size}
      className={`${classes.root} ${classes[themeColor] || classes.darkBlue}`}
      disableRipple
      onClick={onClick}
      {...rest}
    >
      {children}
    </Button>
  );
};

ThemeButton.propTypes = {
  children: PropTypes.node.isRequired,
  themeColor: PropTypes.oneOf(['primary', 'accent', 'secondary', 'lime', 'grey']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  disabled: PropTypes.bool,
  onClick: PropTypes.func
};

ThemeButton.defaultProps = {
  themeColor: 'primary',
  size: 'medium',
  disabled: false,
  onClick: () => {}
};

export default ThemeButton;
